import { useTranslation } from 'react-i18next'
import { SidebarSections } from '@omnea-app/fe-app-shell/sidebar/SidebarSections'
import { useSettingsSections } from './useSettingsSections'

export const SettingsSidebarContent = () => {
  const { t } = useTranslation('settings')
  return <SidebarSections sections={useSettingsSections()} searchPlaceholder={t('search-placeholder')} />
}
